import { render } from "./WordEditor.vue?vue&type=template&id=74d131ba&scoped=true"
import script from "./WordEditor.vue?vue&type=script&lang=js"
export * from "./WordEditor.vue?vue&type=script&lang=js"

import "./WordEditor.vue?vue&type=style&index=0&id=74d131ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d131ba"]])

export default __exports__